import { render } from "./JakoContent.vue?vue&type=template&id=11b089b8"
import script from "./JakoContent.vue?vue&type=script&lang=js"
export * from "./JakoContent.vue?vue&type=script&lang=js"

import "./JakoContent.vue?vue&type=style&index=0&id=11b089b8&lang=css"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__